import CONSTANTS from '@/helpers/constants';
import type { IGeoPosition } from '~/api/IGeoPosition';

export const isValidPosition = (position?: IGeoPosition) => !!(
  position &&
      position.lat &&
      position.lng &&
      Math.abs(position.lat) <= CONSTANTS.FIXED_VALUES.MAX_ABS_LAT &&
      Math.abs(position.lng) <= CONSTANTS.FIXED_VALUES.MAX_ABS_LNG &&
      !CONSTANTS.BAD_POSITION_VALUES.includes(position.lat) &&
      !CONSTANTS.BAD_POSITION_VALUES.includes(position.lng)
);
